<template>
  <div>
    <v-btn @click="$router.push({'name' : 'map-schema-to-related', params:{ schemaId: schema.id }})">
      <v-icon>add</v-icon>
    </v-btn>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <v-data-table v-if="relatedMaps"
                   :headers="headers"
                   :items="relatedMaps"
                   :loading="loading"
                   no-data-text="-"
                   no-results-text="-"
                   :rows-per-page-items="[10,25,50]"
                   class="elevation-1">

      <template v-slot:items="props">
        <td>{{ schema.name}}</td>
        <td>{{ getRelatedSchemaName(props.item.related_schema_id) }}</td>
        <td>{{ props.item.related_value_code }}</td>
        <td>{{ props.item.related_value_name }}</td>
        <td>{{ props.item.type_group_id }}</td>
        <td>{{ props.item.group_code }}</td>
        <td>{{ props.item.group_name }}</td>
        <td>
          <p v-for="field in getMaps(props.item.map)">
           {{ field }}
          </p>
        </td>
        <td>
          <v-btn icon @click="deleteItem(props.item.id)">
            <v-icon>
            delete
          </v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>

  </div>
</template>
<script>
export default {
  computed: {
  },
  methods:{
    deleteItem(id){
      this.$http.delete(`related-map/${id}`).then(()=>{
        this.relatedMaps = this.relatedMaps.filter(el => el.id != id)
      })
    },
    getMaps(map){
      return JSON.parse(map).map(fieldMap =>`${this.getFieldName(fieldMap.id_field)}: ${fieldMap.key}`)
    },
    getFieldName(id){
      if(!this.schema){
        return
      }

      return this.schema.fields.find(f=> f.id == id).name
    },
    getRelatedSchemaName(id){
      let related = this.relateds.find(el => el.id == id)
      return related ? related.name : "-"
    }
  },
  data(){
    return{
      relatedMaps:null,
      loading:false,
      schema: null,
      relateds: [],
      headers:[
        { text: 'Schemat', value: 'schema_id' },
        { text: 'Schemat relacyjny', value: 'related_schema_id' },
        { text: 'Kod', value: 'related_value_code' },
        { text: 'Nazwa', value: 'related_value_name' },
        { text: 'Grupa', value: 'type_group_id' },
        { text: 'Kod grupy', value: 'group_code' },
        { text: 'Nazwa grupy', value: 'group_name' },
        { text: 'Mapowanie', value: 'map' },
        { text: 'Akcje', value: '_' }
      ]
    }
  },
  created() {
    this.loading = true
    let relatedMap = this.$http.get('schema/' + this.$route.params.schemaId + '/related-map')
    let schema = this.$http.get('schema/' + this.$route.params.schemaId)
    let relateds = this.$http.get('related/schema')

    Promise.all([relatedMap, schema, relateds]).then((data) => {
      this.relatedMaps = data[0].data
      this.schema = data[1].data
      this.relateds = data[2].data
      this.relatedMaps.forEach(el => JSON.parse(el.map).map(fieldMap =>`${fieldMap.id_field}: ${fieldMap.key}`))
      this.loading = false

    }).catch((e) => {
      this.$route.push({
        name: "not-found"
      })
    });
  }
}
</script>
<style scoped>

</style>